import PropTypes from 'prop-types'

export const cellShape = PropTypes.shape({
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
})

export const scopeColorShape = PropTypes.shape({
  main: PropTypes.string.isRequired,
  background: PropTypes.string,
})

export const columnShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  color: scopeColorShape.isRequired,
  width: PropTypes.number,
})

export const rowShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  cells: PropTypes.objectOf(cellShape).isRequired,
})

export const sectionShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(rowShape).isRequired,
})
